import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Paginator from '../../../components/paginationCustom';
import { getLoginLogList } from '../actions/LogActions';
import SortingCustom from '../../../components/SortingCustom';
import { Field, reduxForm, reset } from 'redux-form';
import GlobalVariables, { showFormatedDate, showFormatedDateandTimewithsec, resetFiltersAndSorting } from '../../../actions/utilAction';
import { renderDateField, renderTextField } from '../../../components/reduxFields';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
class LoginLogList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CreatedBy: '',
      FromDate: null,
      ToDate: null,
    };
    this.filter = {
      sort_Column: 'logDate',
      sort_Order: 'desc',
      searchText: '',
    };
    this.handleSearchLoginLog = this.handleSearchLoginLog.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    // this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'logDate',
      sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
      contain_filters: {
        CreatedBy: this.state.CreatedBy ? this.state.CreatedBy : '',
        FromDate: this.state.FromDate ? this.state.FromDate : '',
        ToDate: this.state.ToDate ? this.state.ToDate : '',
      },
      pageNumber: page_number ? page_number : 1,
      pageSize: GlobalVariables.pageSize,
    };

    this.props.getLoginLogList(searchObj);
  }
  componentWillMount() {
    this.loadData();
  }
  handleSearchLoginLog(event) {
    // event.preventDefault();
    this.setState({
      CreatedBy: event.CreatedBy ? event.CreatedBy : '',
      // roleName: event.roleName ? event.roleName : '',
      FromDate: event.FromDate ? showFormatedDate(event.FromDate) : '',
      ToDate: event.ToDate ? showFormatedDate(event.ToDate) : '',
    }, () => {
      this.loadData();
    });
  }
  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }
  // handleSearchChange(event) {
  //     if (event.target.value.length > 2) {
  //         this.filter.searchText = event.target.value;
  //         this.loadData();
  //     } else if (event.target.value.length === 0) {
  //         this.filter.searchText = '';
  //         this.loadData();
  //     }
  // }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;

      this.loadData();
    }
  }
  handleReset = () => {
    this.props.dispatch(reset('LoginLogListForm'));
    resetFiltersAndSorting(this.filter, 'createddate', true);
    this.setState({
      CreatedBy: null,
      FromDate: null,
      ToDate: null,
    }, () => {
      this.loadData();
    });
  };

  renderData() {
    return this.props.loginloglist.data.map((data, index) => {
      // console.log(this.props.loginloglist.data);
      return (
        <tr key={index}>
          <td>{data.createdByName}</td>
          <td>{data.userName}</td>
          <td>{data.roleName}</td>
          <td>{data.ipAddress}</td>
          <td className={data.loginAttempt === 'Success' ? 'greenfont' : 'redfont'}>{data.loginAttempt === undefined || data.loginAttempt === null ? '' : data.loginAttempt}</td>
          <td>{data.action}</td>
          <td>{showFormatedDateandTimewithsec(data.logDate)}</td>
        </tr>
      );
    });
  }


  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });

    return (
      <div>
        <h2 className="page_title">Login / Logout Logs</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="row">
              <div className="col-sm-12 mtm-27">
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchLoginLog)}>
                  <div className="row">
                    <div className="col-sm-6"></div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 col-md-4">
                      <Field name="CreatedBy"
                        autoFocus={true}
                        floatingLabelText="Login User"
                        // onChange={this.handleSearchChange}
                        component={renderTextField} />
                    </div>
                    {/* <div className="col-sm-4 col-md-4">
                      <Field name="userName"
                        floatingLabelText="Username"
                        //onChange={this.handleSearchChange}
                        component={renderTextField} />
                    </div> */}
                    {/* <div className="col-sm-4 col-md-4">
                      <Field name="roleName"
                        floatingLabelText="Role Name"
                        // onChange={this.handleSearchChange}
                        component={renderTextField} />
                    </div> */}
                    <div className="col-sm-4 col-md-4">
                      <Field name="FromDate"
                        placeholder="From Date"
                        locale="en-US"
                        selected={this.state.FromDate}
                        onDateChange={this.onDateChange}
                        openToYearSelection = {true}
                        component={renderDateField} />

                    </div>
                    <div className="col-sm-4 col-md-4">
                      <Field name="ToDate"
                        placeholder="To Date"
                        locale="en-US"
                        minDate={this.state.FromDate}
                        selected={this.state.ToDate}
                        onDateChange={this.onDateChange}
                        openToYearSelection = {true}
                        component={renderDateField} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 btn_rt reset-btn">
                      <RaisedButton label="Filter" className="grey_btn" type="Submit" primary={true} />
                      <RaisedButton label="Reset" className="grey_btn ml_15" onTouchTap={this.handleReset} />
                    </div>
                  </div>
                </form>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="table-responsive mt-15">
                      {this.props.loginloglist.data && this.props.loginloglist.data.length ?
                        <table className={tableClass}>
                          <thead>
                            <tr>
                              <th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='createdByName' displayName='Login/Logout by'/></th>
                              <th width="15%"><span>Username</span></th>
                              <th width="15%"><span>Role Name</span></th>
                              <th width="15%"><span>IP Address</span></th>
                              <th width="15%"><span>Login/Logout Attempt</span></th>
                              <th width="5%"><span>Action</span></th>
                              <th width="20%"><SortingCustom setSortColumn={this.setSortColumn} columnName='logDate' displayName='Login/Logout Date'/></th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.renderData()}
                          </tbody>
                        </table>
                        :
                        <table className={tableClass}>
                          <thead>
                            <tr>
                              <th width="15%"><span>Login/Logout by</span></th>
                              <th width="15%"><span>Username</span></th>
                              <th width="15%"><span>Role Name</span></th>
                              <th width="15%"><span>IP Address</span></th>
                              <th width="15%"><span>Login/Logout Attempt</span></th>
                              <th width="5%"><span>Action</span></th>
                              <th width="20%"><span>Login/Logout Date</span></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan="6">
                                <div className="familydl text-center no-record">No record found!</div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      }
                    </div>
                    {this.props.loginloglist.data && this.props.loginloglist.data.length ?
                      <Paginator data={this.props.loginloglist.meta} handlePageChange={(page_number) => this.loadData(page_number)} />
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
LoginLogList = reduxForm({
  form: 'LoginLogListForm',
})(LoginLogList);

function mapStateToProps(state) {
  //console.log('state..........',state.logs);
  return {
    loginloglist: state.logs.loginloglist,
  };

}
export default connect(mapStateToProps, { getLoginLogList })(LoginLogList);



// WEBPACK FOOTER //
// ./src/modules/Logs/components/login_log.js